import { createStore, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';
import createLogger from 'redux-logger';
import rootReducer from './rootReducer';
import history from './middleware/historyMiddleware';

/**
 * Configure main store with root reducer, initial state and given middleware
 * @param {{}} preloadedState Initial state
 * @returns {*}
 */
const configureStore = (preloadedState) => {
    const middleware = [history, thunk];
    /**
     * Logger middleware used only in dev environment to track redux actions
     */
    if (process.env.NODE_ENV === 'development') {
        middleware.push(createLogger());
    }

    const store = createStore(
        rootReducer,
        preloadedState,
        applyMiddleware(...middleware),
    );

    return store;
};

export default configureStore;



// WEBPACK FOOTER //
// ./src/js/configureStore.js